import { RouterModule, Routes } from "@angular/router";
import { AuthLoginComponent } from "./auth-login/auth-login.component";
import { NgModule } from "@angular/core";
import { AppAuthGuard } from "../security/app-auth-guard";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { MultifactorAuthenticationComponent } from "./multifactor-authentication/multifactor-authentication.component";
import { AuthSignupComponent } from "./auth-signup/auth-signup.component";
import { AssignAdministratorComponent } from "./assign-administrator/assign-administrator.component";
import { HelpCenterComponent } from "./help-center/help-center.component";

const routes: Routes = [
    { path : 'login', component : AuthLoginComponent, canActivate: [AppAuthGuard] },
    { path : 'reset-password', component : ResetPasswordComponent },
    { path : 'signup', component : AuthSignupComponent },
    { path : 'login/mfa', component : MultifactorAuthenticationComponent },
    { path : 'assign-administrator', component: AssignAdministratorComponent },
    { path : 'help-center', component: HelpCenterComponent }

];
  
  @NgModule({
      imports: [RouterModule.forChild(routes)],
      exports: [RouterModule]
  })
  export class AuthRoutingModule {}